export default __webpack_public_path__ + "static/media/3rd.25859c40.svg";